export const handleTextAlign = (descriptionPosition) => {
  if (descriptionPosition === 'Center') {
    return 'center';
  } else if (descriptionPosition === 'Right') {
    return 'right';
  } else {
    return 'left';
  }
};
